import { SESSION_SERVICE_TIMEOUT_MS } from '@repo/config';
import { createAuthRequestHeaders } from './create-auth-request-headers';

interface IGetFetchOptionsParams {
  cookieHeader: string;
}

export function createGetFetchOptions({ cookieHeader }: IGetFetchOptionsParams): RequestInit {
  return {
    headers: createAuthRequestHeaders(cookieHeader),
    cache: 'no-store',
    signal: AbortSignal.timeout(SESSION_SERVICE_TIMEOUT_MS),
  };
}
